import script from "./TermsAndConditionsPage.vue?vue&type=script&setup=true&lang=js"
export * from "./TermsAndConditionsPage.vue?vue&type=script&setup=true&lang=js"

import "./TermsAndConditionsPage.vue?vue&type=style&index=0&id=4dae1ca5&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4dae1ca5"]])

export default __exports__